import { MenuItem } from 'react-aria-components'

import { css, cx } from '@portal/styled-system/css'

import { env } from '@/shared/config'
import { useI18n } from '@/shared/lib/i18n'

import { NavbarItem } from '../navbar-item/view'
import { navbarMenu } from '../styles/recipe'
import type { NavbarItemVariant } from '../types'

export function AboutPageLink({ variant = 'default' }: { variant?: NavbarItemVariant }) {
    const { i18n } = useI18n()
    const classes = navbarMenu()
    const href = `/about/taonga-farming-game`

    if (!env.NAVBAR_ABOUT_PAGE_LINK_ENABLE) {
        return null
    }

    if (variant === 'dropdown') {
        return (
            <MenuItem href={href} target="_blank" className={cx(classes.itemNav, css({ textTransform: 'uppercase' }))}>
                <i className={cx('fa-light fa-bird', classes.icon)} />
                &nbsp;{i18n.PORTAL_ABOUT}
            </MenuItem>
        )
    }

    return (
        <NavbarItem
            navbarItemType="link"
            href="/about/taonga-farming-game"
            styles={css.raw({ display: { base: 'none', lg: 'flex' } })}
        >
            {i18n.PORTAL_ABOUT}
        </NavbarItem>
    )
}
